import type { DropdownProps } from '../Dropdown';

export function assertMultiSelect<
  TValue extends string,
  TMultiselect extends boolean,
>({
  multiselect,
  value,
  maxSelectedOptions,
}: Pick<
  DropdownProps<TValue, TMultiselect>,
  'multiselect' | 'value' | 'maxSelectedOptions'
>): void {
  if (!multiselect) {
    return;
  }

  if (!!value && !Array.isArray(value)) {
    throw new Error('value must be an array for multiselect dropdown');
  }

  if (maxSelectedOptions && maxSelectedOptions < 1) {
    throw new Error('maxSelectedOptions must be greater than 0');
  }
}
